import { CoordinatorService } from './coordinator.service';
declare const ace: any;
export class Ace$ {
    constructor(public coords: CoordinatorService) {}

    initializeEditor(editor: any, langTools: any): void {
        // editor.setTheme('ace/theme/monokai')
        editor.session.setMode('ace/mode/javascript');
        editor.setOptions({
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
        });

        const snippetText = `
            snippet $residue
                    $residue
            snippet $rename
                    $rename
`;

        const snippetManager = ace.require('ace/snippets').snippetManager;

        var customSnippets = [
            {
                content: 'stage("${1: project|databin|preview|collection|report}")',
                name: 'stage',
                tabTrigger: 'stage',
            },
            {
                content: '\\$collection',
                name: '$collection',
                tabTrigger: '$collection',
            },
            {
                content: '\\$preview',
                name: '$preview',
                tabTrigger: '$preview',
            },
            {
                content: 'create("${1}")',
                name: 'create',
                tabTrigger: 'create',
            },
            {
                content: 'delete(${1})',
                name: 'delete',
                tabTrigger: 'delete',
            },
            {
                content: 'edit()',
                name: 'edit',
                tabTrigger: 'edit',
            },
            {
                content: 'and(${1})',
                name: 'and',
                tabTrigger: 'and',
            },
            {
                content: 'or(${1})',
                name: 'or',
                tabTrigger: 'or',
            },
            {
                content: 'add(${1})',
                name: 'add',
                tabTrigger: 'add',
            },
            {
                content: 'not(${1})',
                name: 'not',
                tabTrigger: 'not',
            },
            {
                content: 'clone()',
                name: 'clone',
                tabTrigger: 'clone',
            },
            {
                content: 'close()',
                name: 'close',
                tabTrigger: 'close',
            },
            {
                content: 'attach()',
                name: 'attach',
                tabTrigger: 'attach',
            },
            {
                content: 'const ${1:h} = hitset()',
                name: 'hitset',
                tabTrigger: 'hitset',
            },
            {
                content: 'const ${1:s} = subset("${2}")',
                name: 'subset',
                tabTrigger: 'subset',
            },
            {
                content: 'const ${1:kw} = keyword("${2}")',
                name: 'keyword',
                tabTrigger: 'keyword',
            },
            {
                content: 'const ${1:dtb} = databin("${2}")',
                name: 'databin',
                tabTrigger: 'databin',
            },
            {
                content: 'const ${1:kwg} = keywordGroup("${2}")',
                name: 'keywordGroup',
                tabTrigger: 'keywordGroup',
            },
            {
                content: 'const ${1:tag} = tagGroup("${2}")',
                name: 'tagGroup',
                tabTrigger: 'tagGroup',
            },
            {
                content: 'const ${1:rat} = ratingGroup("${2}")',
                name: 'ratingGroup',
                tabTrigger: 'ratingGroup',
            },
            {
                content: 'log()',
                name: 'log',
                tabTrigger: 'log',
            },
            {
                content: 'const s = settings()',
                name: 'settings',
                tabTrigger: 'setings',
            },
            {
                content: 'display()',
                name: 'display',
                tabTrigger: 'display',
            },
            {
                content: 'report()',
                name: 'report',
                tabTrigger: 'report',
            },
            {
                content: 'saveFile(${1: string|object}, ${2: "filename.any"})',
                name: 'saveFile',
                tabTrigger: 'saveFile',
            },
            {
                content: 'getNode("${1: /top/second/third}")',
                name: 'getNode',
                tabTrigger: 'getNode',
            },
        ];

        // editor.completers.length = 0
        snippetManager.register(customSnippets, 'javascript');
        // const customCompleter = {
        //     getCompletions: function (editor: any,
        //         session: any, pos: any, prefix: string, callback: Function) {
        //         var snippetCompleter = ace.require("ace/ext/snippets").snippetCompleter
        //         snippetCompleter.getCompletions(editor, session, pos, prefix,
        //             function (err: Error, completions: any[]) {
        //                 callback(null, [])
        //             })
        //     }
        // }

        // langTools.setCompleters([customCompleter])

        // editor.commands.on("afterExec", (e: any) => {
        //     console.log(e.command.name)
        //     if (["insertstring", "del", "backspace"].includes(e.command.name)) {
        //         editor.completers.length = 0
        //         const cursor = editor.getCursorPosition()
        //         const line = editor.session.getLine(cursor.row)
        //         const lineStart = line.slice(0, cursor.column)
        //         // console.log(editor.completers)
        //         const i = lineStart.lastIndexOf("$")
        //         if (i === -1) return
        //         const suffix = lineStart.slice(i)
        //         if (lineStart.endsWith(suffix)) {
        //             console.log("SUFFIX", suffix)
        //             switch (suffix) {
        //                 case "$":
        //                     editor.completers.push(basicCompleter)
        //                     break
        //                 case "$fun.":
        //                     editor.completers.push(funCompleter)
        //                     break
        //             }
        //             return editor.execCommand("startAutocomplete")
        //         }
        //     }
        // })

        // const basicCompleter: any = this.completerFactory([
        //     {
        //         name: "$",
        //         // caption: 'Functions',
        //         value: '$fun',
        //     },
        // ])

        const funCompleter: any = this.completerFactory([
            {
                name: '$',
                caption: 'Functions',
                value: '$fun',
            },

            {
                name: 'stage',
                caption: 'Stage: project',
                value: 'stage("project")',
            },
            {
                name: 'stage',
                caption: 'Stage: collection',
                value: 'stage("collection")',
            },
            {
                name: 'stage',
                caption: 'Stage: preview',
                value: 'stage("preview")',
            },
            {
                name: 'stage',
                caption: 'Stage: report',
                value: 'stage("report")',
            },
        ]);

        // editor.completers = [funCompleter]
        // langTools.addCompleter(basicCompleter)
        // langTools.addCompleter(funCompleter)
    }

    completerFactory(completions: any[]) {
        return {
            getCompletions: function (editor: any, session: any, pos: any, prefix: string, callback: Function) {
                console.log(`COMPLETER |${prefix}|`);
                callback(
                    null,
                    completions.map((c: any) => {
                        if (c.caption && !c.meta) c.meta = c.value;
                        return c;
                    }),
                );
                console.log(editor, session, pos);
            },
        };
    }
}
